import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ANNOUNCEMENT_API_URL } from '../../utils/apiEndpoints';
import clientService from '../../apiClient';
import { genWorkspaceHeader } from '../../utils/constants';

const initialState = {
  newsletter: {
    title: '',
    description: '',
    tags: [],
    announcements: [],
    thumbnail: '',
  },
};

const newsletterSlice = createSlice({
  name: 'newsletterSlice',
  initialState,
  reducers: {
    updateNewsletter: (state, action) => {
      state.newsletter.title = action.payload.data.title;
      state.newsletter.description = action.payload.data.description;
      state.newsletter.tags = action.payload.data.tags;
      state.newsletter.announcements = action.payload.data.announcements;
      state.newsletter.thumbnail = action.payload.data.thumbnail;
    },
  },
});
export const { updateNewsletter } = newsletterSlice.actions;
export default newsletterSlice.reducer;
